export default {"src":"/_next/static/media/cross-functional-coordination.f7cf1f7e.svg","height":484,"width":484,"blurWidth":0,"blurHeight":0};